import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getDomain from 'getdomain';

import appConfig from '@nerdwallet/app-config';

// eslint-disable-next-line import/extensions -- directive added automatically by Shepherd migration
import Default from './default.jsx';
// eslint-disable-next-line import/extensions -- directive added automatically by Shepherd migration
import InvestingAdvisor from './custom/investing-advisor.jsx';
// eslint-disable-next-line import/extensions -- directive added automatically by Shepherd migration
import PrequalAmex from './custom/prequal-amex.jsx';
// eslint-disable-next-line import/extensions -- directive added automatically by Shepherd migration
import PrequalChase from './custom/prequal-chase.jsx';
import CCCardArt from './custom/cc-card-art/index';

import publishCreditCardBrowsePageClick from '../lib/publish-credit-card-browse-page-click';
import withCJPublisherTag from './custom/with-cj-publisher-tag';

// TODO use ErrorBoundary when React 16 is out
// to render DefaultRoute in case of any render error
class Container extends Component {
  async componentDidMount() {
    if (typeof window === 'undefined') {
      return;
    }
    const { product } = this.props;
    // Only call publishCreditCardBrowsePageClick for credit card clicks
    if (product.marketplaceOfferProductType === 'credit_cards') {
      await publishCreditCardBrowsePageClick();
    }
    // If an automatic redirect was not requested on the server, then redirectTimeout
    // will be null or undefined
    if (
      this.props.redirectSuppressed === false &&
      typeof this.props.redirectTimeout === 'number'
    ) {
      setTimeout(() => {
        const destinationDomain = getDomain.get(
          this.props.product.destinationUrl
        );
        if (appConfig.CJ_PUBLISHER_TAG_DOMAINS.includes(destinationDomain)) {
          // eslint-disable-next-line no-console
          console.log('navigating via CJ');
          // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef
          cj.navigate(this.props.product.destinationUrl);
        } else {
          window.location.href = this.props.product.destinationUrl;
        }
      }, this.props.redirectTimeout);
    }

    // Expose GTM data for all verticals
    // in a way that matches the gtm data layer spec
    // https://nerdwallet.atlassian.net/wiki/pages/viewpage.action?pageId=121218111#GoogleTagManager(GTM)-Variablescurrentlyexposed

    // Always use `push` to add values.
    // This avoids accidentally replacing a previously defined dataLayer.
    const dataLayer = window.dataLayer || [];

    if (product.productId) {
      dataLayer.push({
        event: product.gtmEvent,
        gtmReferPath: product.referPath,
        gtmContentIds: product.productId,
        gtmClickId: product.uniqueClickId,
        gtmQuantcastLabel: product.quantcastLabel,
        gtmPageTopic: product.gtmPageTopic,
        gtmPageVertical: product.vertical,
      });
    }
  }

  getComponent() {
    switch (this.props.componentName) {
      case 'InvestingAdvisor':
        return InvestingAdvisor;
      case 'PrequalAmex':
        return PrequalAmex;
      case 'PrequalChase':
        return PrequalChase;
      case 'CCCardArt':
        return CCCardArt;
      default:
        return Default;
    }
  }

  render() {
    const { error, product, redirectSuppressed, missingTrackingParams } =
      this.props;

    if (error) {
      return (
        <div
          className="route-container"
          style={{ margin: '100px auto', textAlign: 'center' }}
        >
          {/* eslint-disable-next-line react/no-unescaped-entities -- directive added automatically by Shepherd migration */}
          <p>Whoops, we're having trouble pulling up that offer for you.</p>
          <p>Click the back button in your browser to try again.</p>
        </div>
      );
    }

    const RedirectComponent = this.getComponent();

    return (
      <div className="route-container">
        <RedirectComponent
          product={product}
          missingTrackingParams={missingTrackingParams}
          suppressRedirect={redirectSuppressed}
        />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.propTypes = {
  error: PropTypes.bool,
  componentName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  product: PropTypes.object,
  redirectSuppressed: PropTypes.bool.isRequired,
  redirectTimeout: PropTypes.number,
  missingTrackingParams: PropTypes.arrayOf(PropTypes.string),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.defaultProps = {
  error: false,
  componentName: 'Default',
  product: {},
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  redirectSuppressed: false,
  redirectTimeout: null,
  missingTrackingParams: [],
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Container.displayName = 'RedirectContainer';

const mapStateToProps = ({
  error,
  product,
  componentName,
  redirect: {
    suppressed: redirectSuppressed,
    timeout: redirectTimeout,
    missingTrackingParams,
  },
}) => ({
  error,
  product,
  componentName,
  missingTrackingParams,
  redirectSuppressed,
  redirectTimeout,
});

// When running tests, we don't want to connect to a store
export { Container as ContainerComponent };

export default connect(mapStateToProps)(withCJPublisherTag(Container));
